import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { CrossmarkIcon } from 'assets/icons';
import { BlockIcon } from 'assets/icons/signsAndSymbols/BlockIcon';
import { Button, CancelButton } from 'components/common';
import { ButtonWrapper } from 'components/common/buttons/ButtonWrapper.styled';
import {
  Backdrop,
  Description,
  RandomlyPositionedModal,
} from 'components/common/CustomModal/CustomModal.styled';
import { Flex } from 'components/styled/Flex';

import { IconWrapper, Title } from './DeleteModal.styled';

interface IDeleteModal {
  title: string;
  titleIcon?: ReactNode;
  description?: string;
  additionalDescription?: string;
  handleDelete?: () => void;
  showModal: boolean;
  dismissModal: () => void;
  isLoading?: boolean;
  confirmLabel?: string;
  cancelLabel?: string;
  swapButtonActions?: boolean; // used for extra dangerous actions
}

export const DeleteModal = ({
  title,
  titleIcon,
  description,
  additionalDescription,
  handleDelete,
  showModal,
  dismissModal,
  isLoading,
  confirmLabel,
  cancelLabel,
  swapButtonActions,
}: IDeleteModal) => {
  const { t } = useTranslation();
  const { colors } = useTheme();
  const renderBackdrop = (props: any) => <Backdrop {...props} />;

  return (
    <>
      <RandomlyPositionedModal
        show={showModal}
        onHide={dismissModal}
        renderBackdrop={renderBackdrop}
        aria-labelledby="modal-label"
      >
        <>
          <Flex justifyContent="space-between" margin="0 0 1.5rem 0">
            <Flex alignItems="flex-start" gap="0.5rem">
              <IconWrapper>{titleIcon ? titleIcon : <BlockIcon />}</IconWrapper>

              <Title>{t(title)}</Title>
            </Flex>
            <IconWrapper onClick={dismissModal}>
              <CrossmarkIcon fill={colors.black_60} />
            </IconWrapper>
          </Flex>

          {description && <Description>{description}</Description>}

          {additionalDescription && <Description>{additionalDescription}</Description>}

          <Flex justifyContent="flex-start" height="100%" alignItems="flex-end">
            <ButtonWrapper>
              <CancelButton
                onClick={swapButtonActions && handleDelete ? handleDelete : dismissModal}
                label={cancelLabel}
              />

              {handleDelete && (
                <Button
                  type="reset"
                  color={'red'}
                  isFetching={isLoading}
                  label={confirmLabel || 'Delete'}
                  onClick={swapButtonActions ? dismissModal : handleDelete}
                />
              )}
            </ButtonWrapper>
          </Flex>
        </>
      </RandomlyPositionedModal>
    </>
  );
};
